<!--  -->
<template>
  <div>

    <div class="tabselecr_box">
      <div class="search_box">
        <el-input
          v-model="query.keywords"
          clearable
          style="width:400px;"
          placeholder="请输入员工编号/员工ID/员工姓名"
        />
        <el-input
          v-model="query.tag"
          clearable
          style="width:200px;"
          placeholder="请输入标签"
        />
        <el-select
          v-if="query.staff_pool!==2"
          v-model="query.login_status"
          placeholder="请选择登录状态"
        >
          <el-option
            v-for="item in optionsr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select
          v-if="query.staff_pool!==2"
          v-model="query.disable_status"
          placeholder="请选择账号状态"
        >
          <el-option
            v-for="item in optionsraccount"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchclick"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh-right"
          @click="rechargeclick"
        >重置</el-button>
        <el-button
          type="primary"
          icon="el-icon-edit"
          :disabled="multipleSelection.length === 0"
          @click="openSetTagDialog"
        >设置标签</el-button>
        <!-- <el-button
          type="warning"
          icon="el-icon-thumb"
          @click="anthall"
        >授权企业</el-button> -->
        <el-button
          type="primary"
          icon="el-icon-download"
          @click="clickExport"
        >导出</el-button>
        <el-button
          v-if="query.corp_id"
          type="success"
          icon="el-icon-thumb"
          @click="reawrgfeishu"
        >转发飞书客服</el-button>
        <el-button
          type="success"
          icon="el-icon-tickets"
          @click="generatelinkrw"
        >生成获客链接</el-button>
        <el-button
          type="primary"
          icon="el-icon-upload"
          :disabled="multipleSelection.length === 0"
          @click="pushcard()"
        >推送名片</el-button>

      </div>
      <!-- <div>
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
      </div> -->
    </div>
    <el-table
      ref="multipleTable"
      v-loading="loading"
      class="staff-table"
      :data="tableData"
      border
      max-height="700"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
        class-name="selection-col-expand"
      />
      <!-- <el-table-column
        prop="id"
        label="id"
        align="center"
        width="50"
      /> -->

      <el-table-column
        prop="corp_name"
        label="企业名称"
        align="center"
        width="300"
      />
      <!-- <el-table-column
        prop="suite_id"
        label="应用id"
        align="center"
        width="170"
      /> -->
      <el-table-column
        prop="employee_no"
        label="员工编号"
        align="center"
        width="280"
      />
      <el-table-column
        prop="tag"
        label="标签"
        align="center"
        width="280"
      />
      <el-table-column
        prop="name"
        label="员工姓名"
        align="center"
        width="150"
      />
      <el-table-column
        prop="active_status_text"
        label="激活状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span :class="{'active': scope.row.active_status, 'inactive': !scope.row.active_status}">
            {{ scope.row.active_status_text }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="alias_name"
        label="员工别名"
        align="center"
        width="100"
      />
      <el-table-column
        prop="score"
        label="权重分数"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <div :style="getCellStyle(row)">
            {{ row.score }}
            <!-- <i
              class="el-icon-s-opportunity"
            /> -->
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="员工头像"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <!-- <img v-if="scope.row.avatar!==''" :src="scope.row.avatar" alt="" style="width:80px;height:80px"> -->
          <el-avatar
            :size="50"
            :src="scope.row.avatar"
          >
            <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png">
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        prop="login_platform_text"
        label="登录平台"
        align="center"
        width="100"
      />
      <el-table-column
        prop="phone_name"
        label="手机编号"
        align="center"
        width="100"
      />
      <el-table-column
        v-if="query.staff_pool != 2"
        prop="user_id"
        label="登录状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.online_status == 2"
            size="mini"
            type="primary"
            @click="login(scope.row,scope.row.employee_no)"
          >登录</el-button>
          <div v-if="scope.row.online_status == 1"><i
            class="el-icon-success"
            style="color:#85ce61"
          />已登录</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_id"
        label="账号状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <div><i
            v-if="scope.row.disable_status == 1"
            class="el-icon-success"
            style="color:#85ce61"
          /><i
            v-if="scope.row.disable_status == 2"
            class="el-icon-error"
            style="color:#F56C6C"
          />{{ scope.row.disable_status_text }}</div>
          <el-button
            v-if="scope.row.disable_status == 2"
            size="mini"
            type="primary"
            @click="unblock(scope.row.employee_no,scope.row.disable_status)"
          >解封</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_id"
        label="是否接收小程序"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <!-- <el-switch
            v-model="scope.row.receive_miniprogram"
            active-text="接收"
            inactive-text="不接收"
            :active-value="1"
            :inactive-value="2"
            @change="changewr($event,scope.row)"
          /> -->

          <div style="position: relative; display: inline-block;">
            <el-switch
              v-model="scope.row.receive_miniprogram"
              :width="50"
              active-color="#13ce66"
              inactive-color="rgb(191,191,191)"
              :active-value="1"
              :inactive-value="2"
              @change="changewr($event,scope.row)"
            />
            <div
              v-if="scope.row.receive_miniprogram === 1"
              style="color: #fff;position: absolute;top: 2px;left: 7px;"
            >是</div>
            <div
              v-else
              style="color: #fff;position: absolute;top: 2px;right: 7px;"
            >否</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="client_ip"
        label="客户端ip"
        align="center"
        width="170"
      />
      <el-table-column
        prop="client_ip"
        label="登录/登出时间"
        align="center"
        width="170"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.online_status == 1">
            {{ scope.row.login_at }}
          </div>
          <div v-if="scope.row.online_status == 2">
            {{ scope.row.login_out_at }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="login_version_text"
        label="登录版本"
        align="center"
        width="150"
      />
      <el-table-column
        prop="kf_feishu_user_name"
        label="飞书客服名称"
        align="center"
        width="170"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
        width="170"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
        width="150"
      />
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="150"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <!-- <el-button type="warning" size="mini" @click="prwiedit(scope.row)">预览</el-button> -->
          <!-- <el-button type="primary" size="mini" style="margin-bottom:10px" @click="look(scope.row)">拉取员工外部用户</el-button>
          <el-button v-if="query.staff_pool != 2" type="warning" size="mini" :disabled="scope.row.online_status != 1" @click="privatechat(scope.row)">私聊</el-button>
          <el-button v-if="query.staff_pool != 2" type="primary" size="mini" @click="bandclient(scope.row)">绑定客户端</el-button>
          <el-button v-if="query.staff_pool === 2" type="success" size="mini" @click="edit(1,scope.row)">绑定管理员</el-button>
          <el-button v-else type="success" style="margin-top:10px" size="mini" @click="edit(2,scope.row)">修改管理员</el-button>
          <el-button type="success" style="margin-top:10px" size="mini" @click="toQRcode(scope)">创建二维码</el-button>
          <el-button type="warning" size="mini" @click="pulling(scope.row.employee_no)">拉取第三方客户</el-button>
          <el-button type="success" size="mini" @click="lookstrategy(scope.row.employee_no)">查看绑定策略</el-button>
          <el-button v-if="scope.row.online_status == 1" type="danger" size="mini" @click="signout(scope.row.employee_no)">登出</el-button> -->
          <!-- <el-button type="danger" size="mini" @click="deteleter(scope.row.customer_message_no)">删除</el-button> -->

          <el-dropdown
            trigger="click"
            placement="bottom"
            @command="(command)=>handleCommand(command,scope.row)"
          >
            <span
              class="el-dropdown-link"
              style="cursor: pointer;"
            >
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown" class="staff-more-menu">
              <div class="staff-more-cols">
                <div class="staff-more-col">
                  <el-button
                    type="success"
                    size="mini"
                    @click="look(scope.row)"
                  >拉取员工外部用户</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="interiorGroupPull(scope.row)"
                  >同步员工群聊</el-button>
                  <el-button
                    v-if="query.staff_pool != 2"
                    type="success"
                    size="mini"
                    @click="privatechat(scope.row)"
                  >私聊</el-button>
                  <el-button
                    v-if="query.staff_pool != 2"
                    type="success"
                    size="mini"
                    @click="bandclient(scope.row)"
                  >绑定客户端</el-button>
                  <el-button
                    v-if="query.staff_pool === 2"
                    type="success"
                    size="mini"
                    @click="edit(1,scope.row,true)"
                  >绑定管理员</el-button>
                  <el-button
                    v-else
                    type="success"
                    size="mini"
                    @click="edit(2,scope.row,true)"
                  >修改管理员</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="toQRcode(scope)"
                  >创建二维码</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="pulling(scope.row.employee_no)"
                  >拉取第三方客户</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="lookstrategy(scope.row.employee_no)"
                  >查看绑定策略</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="numberfans(scope.row.employee_no)"
                  >查看粉丝数量</el-button>
                  <el-button
                    v-if="scope.row.online_status == 1"
                    type="danger"
                    size="mini"
                    @click="signout(scope.row.employee_no)"
                  >登出</el-button>
                </div>
                <div class="staff-more-col">
                  <el-button
                    :disabled="scope.row.online_status != 1"
                    type="danger"
                    size="mini"
                    @click="compulsorytermination(scope.row.wx_id)"
                  >强制解除静置</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="updataGroup(scope.row.employee_no)"
                  >更新群聊策略</el-button>
                  <el-button
                    :disabled="scope.row.online_status == 1"
                    type="success"
                    size="mini"
                    @click="setLogin(scope.row.employee_no)"
                  >设置已登录</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="pushonewayfriend(scope.row)"
                  >拉取单向好友</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="Setloginversion(scope.row)"
                  >设置登录版本</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="Setloginverspeople(scope.row)"
                  >设置转发消息员工</el-button>
                  <el-dropdown
                    trigger="click"
                    placement="bottom"
                    class="staff-more-sub"
                    @click.native.stop
                  >
                    <el-button
                      type="success"
                      size="mini"
                    >
                      设置登录平台<i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="setLoginPlatform(scope.row, 1)"
                        >无</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="setLoginPlatform(scope.row, 2)"
                        >由创</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="setLoginPlatform(scope.row, 3)"
                        >企微宝</el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          type="primary"
                          size="mini"
                          @click="setLoginPlatform(scope.row, 4)"
                        >由创+</el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button
                    type="primary"
                    size="mini"
                    class="butsize btn-purple"
                    @click="openMessageIntervalDialog(scope.row)"
                  >设置消息间隔</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    @click="openChatRobotWebhookDialog(scope.row)"
                  >设置内部群机器人</el-button>
                </div>
              </div>
            </el-dropdown-menu>
          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <pagination-right
      :current-page="query.page"
      :page-sizes="[100]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="选择服务商"
      :visible.sync="choosecontet"
      :append-to-body="true"
      width="20%"
    >
      <el-select
        v-model="value"
        placeholder="请选择服务商"
      >
        <el-option
          v-for="item in options"
          :key="item.provider_id"
          :label="item.provider_name"
          :value="item.provider_id"
        />
      </el-select>
      <div style="margin-top:20px">
        <el-button
          type="primary"
          @click="choosesumbit"
        >确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="企业授权"
      :visible.sync="lookpassword"
      :append-to-body="true"
      width="20%"
    >
      <div
        v-loading="loadinglink"
        class="qr_box"
        element-loading-background="transparent"
      >
        <img
          v-if="link!=''"
          v-loading="loadinglink"
          :src="link"
          style="width:200px;height:200px"
        >
      </div>
    </el-dialog>
    <el-dialog
      title="私聊"
      :visible.sync="privatechatdialog"
      class="fullscreen"
      :append-to-body="true"
      :fullscreen="true"
      @closed="closed"
    >
      <!-- :destroy-on-close="true" -->
      <div
        v-loading="privatechatdialogloading"
        class="qr_box"
        element-loading-background="transparent"
      >
        <privatechat ref="privatechatview" />
      </div>
    </el-dialog>
    <el-dialog
      title="登录"
      :visible.sync="qrcodedialog"
      :append-to-body="true"
      width="40%"
      @close="qrcolose"
    >
      <div style="text-align:center;margin-bottom: 10px;">
        <div style="color:#F56C6C;font-size: 18px;">请确保当前手机扫码员工为</div>
        <div style="color:#F56C6C;font-size: 18px;margin-top: 15px;">{{ itemobj.name }}({{ itemobj.corp_name }})</div>
        <div style="color:#F56C6C;font-size: 18px;margin-top: 15px;">{{ itemobj.client_ip }}<span v-if="area!=''">({{ area }})</span> </div>

      </div>
      <div
        v-loading="qrcodedialogloading"
        class="qr_boxr"
        element-loading-background="transparent"
        style="text-algin:center"
      >
        <div
          v-if="qrCountdown > 0"
          style="text-align:center;margin-top: 20px;color:#409EFF;font-size: 16px; position: relative; top: 20px;"
        >
          {{ formatQrCountdown(qrCountdown) }}
        </div>
        <img
          :src="qrimg"
          alt=""
          style="width:200px"
        >
      </div>
      <div
        v-if="qrimg!=''"
        class="codebox"
      >
        <div class="codebox-label">验证码</div>
        <div class="otp-block">
          <div
            ref="otpWrap"
            class="otp-verify-row"
          >
            <input
              v-for="(_, i) in codeDigits"
              :key="i"
              :value="codeDigits[i]"
              type="text"
              inputmode="numeric"
              maxlength="1"
              autocomplete="one-time-code"
              class="otp-cell"
              @input="onOtpInput(i, $event)"
              @keydown="onOtpKeydown(i, $event)"
              @paste="onOtpPaste(i, $event)"
            >
          </div>
          <p class="otp-hint">
            若登录发现手机接收到验证码，请 10 秒后再填入验证码并点击确定；否则扫码完毕关闭弹窗即可。
          </p>
        </div>
      </div>
      <div
        v-if="qrimg!=''"
        class="onc_box"
      ><el-button
        type="primary"
        @click="sumbitr"
      >确定</el-button></div>
    </el-dialog>
    <el-dialog
      title="管理员"
      :visible.sync="admindialogstatus"
      :append-to-body="true"
      :destroy-on-close="true"
      width="20%"
    >
      <admindialog
        ref="admindialogview"
        @updata="updata"
      />
    </el-dialog>
    <el-dialog
      title="绑定客户端"
      :visible.sync="bandclenddialog"
      :append-to-body="true"
      :destroy-on-close="true"
      width="70%"
    >
      <administratorsdia
        ref="administratorsdiaview"
        @callback="callback"
        @undind="undind"
      />
    </el-dialog>
    <el-dialog
      title="查看绑定策略"
      :visible.sync="bandVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <untieband
        ref="untiebandview"
        @closer="closer"
      />
    </el-dialog>

    <el-dialog
      title="转发飞书"
      :visible.sync="forwardfeishuVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <forwardfeishudialog
        ref="forwardfeishudialogview"
        @feiupdata="feiupdata"
      />
    </el-dialog>

    <el-dialog
      title="设置登录版本"
      :visible.sync="setloginversionVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <loginversion
        ref="loginversionview"
        @vasionupdata="vasionupdata"
      />
    </el-dialog>

    <el-dialog
      title="生成获客地址"
      :visible.sync="generatedialofer"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="30%"
    >
      <generatedialog
        ref="generatedialogview"
      />
    </el-dialog>

    <el-dialog
      title="设置标签"
      :visible.sync="setTagDialogVisible"
      :append-to-body="true"
      width="400px"
      @closed="tagInput = ''"
    >
      <p v-if="multipleSelection.length" style="margin-bottom: 15px; color: #909399; font-size: 12px;">
        已选择 {{ multipleSelection.length }} 名员工
      </p>
      <el-form label-width="80px">
        <el-form-item label="标签">
          <el-input
            v-model="tagInput"
            placeholder="请输入标签"
            clearable
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setTagDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSetTag">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="选择推粉类型"
      :visible.sync="fansTypeDialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
    >
      <div style="margin-bottom: 20px; color: #F56C6C;">
        <div>该选项单选</div>
      </div>
      <div v-if="multipleSelection.length === 1" class="fans-count-box">
        <span class="fans-count-item">全量粉：{{ all_fans_count }}</span>
        <span class="fans-count-item">单删粉：{{ delete_fans_count }}</span>
        <span class="fans-count-item">活粉：{{ valid_fans_count }}</span>
      </div>
      <el-radio-group v-model="fansType">
        <el-radio :label="1">全量</el-radio>
        <el-radio :label="2">单删</el-radio>
        <el-radio disabled :label="3">活粉</el-radio>
      </el-radio-group>
      <div style="display: flex;align-items: center;margin-top: 20px;">
        <div style="flex-shrink: 0;">推送数量：</div>
        <el-input-number
          v-model="sendNum"
          :min="1"
          :precision="0"
          style="width: 100%;"
        />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="fansTypeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmStartPush">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="承接企业员工"
      :visible.sync="receiveEmployeeDialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="750px"
      @opened="loadReceiveEmployeeList"
      @closed="receiveEmployeeRow = null"
    >
      <soucelisttwo
        ref="receiveEmployeeSoucelistview"
        @labelsiurwe="onReceiveEmployeeConfirm"
      />
    </el-dialog>

    <el-dialog
      title="设置消息间隔"
      :visible.sync="messageIntervalDialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="600px"
      @closed="messageIntervalRow = null"
    >
      <div class="message-interval-row">
        <span class="message-interval-label">
          消息间隔
        </span>
        <el-input-number
          v-model="messageIntervalMin"
          controls-position="right"
          class="message-interval-input"
        />
        <span class="message-interval-unit">秒</span>
        <span class="message-interval-sep">~</span>
        <el-input-number
          v-model="messageIntervalMax"
          controls-position="right"
          class="message-interval-input"
        />
        <span class="message-interval-unit">秒</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="messageIntervalSubmitting"
          @click="submitMessageInterval"
        >确定</el-button>
        <el-button @click="messageIntervalDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="设置内部群机器人"
      :visible.sync="chatRobotWebhookDialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="720px"
      @open="fillChatRobotWebhook"
      @closed="resetChatRobotWebhookDialog"
    >
      <el-form label-width="90px">
        <el-form-item label="webhook">
          <el-input
            v-model="chatRobotWebhookUrl"
            placeholder="请输入 webhook"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chatRobotWebhookDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="chatRobotWebhookSubmitting"
          @click="submitChatRobotWebhook"
        >确定</el-button>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  spCorpcorpUsersList,
  spCorpfetchExternalContacts,
  supplierlist,
  authPage,
  getLoginQrcode,
  pullFriendList,
  upToolbindClient,
  setReceiveMiniprogram,
  upToollogout,
  Unblocklear,
  upToolliftingBan,
  loginVerifyCode,
  syncChatGroupsByUser,
  pullGroupStrategy,
  setUpLogin,
  setUpLoginPlatform,
  spCorpgetOneWayFriends,
  messagecorrelationEmployee,
  setCorpUserTag,
  createPushCardTask,
  setReceiveEmployee,
  setSpokesfrequency,
  setChatRobotWebhook,
  fansCount
} from '@/api/officialaccount.js'
import admindialog from './admindialog.vue'
import privatechat from './privatechat.vue'
// import administratorsdia from './administratorsdia.vue'

import administratorsdia from './administratorsdia.vue'
import untieband from './untieband.vue'
import forwardfeishudialog from './forwardfeishudialog.vue'
import { upToolunbind } from '@/api/officialaccount.js'
import XLSX from 'xlsx'
import timeFormate from '@/utils/mixins/convertToHump.js'
import loginversion from './loginversion.vue'
import generatedialog from './generatedialog.vue'
import soucelisttwo from '../../weworkPhoneList/components/soucelisttwo.vue'
export default {
  components: { PaginationRight, privatechat, admindialog, administratorsdia, untieband, forwardfeishudialog, loginversion, generatedialog, soucelisttwo },
  mixins: [timeFormate],
  // eslint-disable-next-line vue/require-prop-types
  props: ['getqrcodelist'],
  data() {
    return {
      fansType: 2, // 选择的推粉类型（单选，用于开始推送名片）
      sendNum: 1, // 推送数量，最小值为1
      fansTypeDialogVisible: false, // 推粉类型选择弹窗
      addQRcodeshow: false,
      tableData: [],
      total: null,
      loading: false,
      query: {
        page: 1,
        pageSize: 100,
        keywords: null,
        tag: null,
        corp_id: null,
        staff_pool: null,
        login_status: 0,
        disable_status: 0
      },
      options: [],
      value: null,
      link: '',
      loadinglink: false,
      lookpassword: false,
      choosecontet: false,
      privatechatdialog: false,
      privatechatdialogloading: false,
      qrcodedialog: false,
      qrimg: '',
      qrcodedialogloading: false,
      admindialogstatus: false,
      bandclenddialog: false,
      optionsr: [
        {
          value: 0,
          label: '全部登录状态'
        },
        {
          value: 1,
          label: '已登录'
        },
        {
          value: 2,
          label: '未登录'
        }
      ],
      optionsraccount: [
        {
          value: 0,
          label: '全部账号状态'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '禁用'
        }
      ],
      bandVisible: false,
      forwardfeishuVisible: false,
      itemobj: {},
      multipleSelection: [],
      setTagDialogVisible: false,
      tagInput: '',
      area: '',
      qrCountdown: 0,
      elxtcorp_name: '',
      codeDigits: ['', '', '', '', '', ''],
      setloginversionVisible: false,
      generatedialofer: false,
      receiveEmployeeDialogVisible: false,
      receiveEmployeeRow: null,
      messageIntervalDialogVisible: false,
      messageIntervalRow: null,
      messageIntervalMin: 3,
      messageIntervalMax: 5,
      messageIntervalSubmitting: false,
      chatRobotWebhookDialogVisible: false,
      chatRobotWebhookRow: null,
      chatRobotWebhookUrl: '',
      chatRobotWebhookSubmitting: false,
      delete_fans_count: null,
      valid_fans_count: null,
      all_fans_count: null
    }
  },
  watch: {
    qrimg(val) {
      if (val && this.qrcodedialog) {
        this.$nextTick(() => {
          this.focusOtpCell(0)
        })
      }
    }
  },
  created() {
    // this.list()
  },
  activated() {
    // eslint-disable-next-line eqeqeq
    const status = JSON.stringify(this.$route.params) == '{}'
    console.log('🚀 ~ status:', status)
    if (status === false) {
      console.log('222222', this.$route.params)
      this.query.keywords = this.$route.params.employee_no
      this.list()
    } else {
      // this.query.keywords = null
      // this.tableData = []
    }
  },
  mounted() {},
  beforeDestroy() {
    this.clearQrCountdown()
  },
  methods: {
    async getFansCount() {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请先选择员工')
        return
      }
      const res = await fansCount({
        employee_no: this.multipleSelection.map(item => item.employee_no).join(',')
      })
      console.log('res', res)
      this.delete_fans_count = res.data.delete_fans_count
      this.valid_fans_count = res.data.valid_fans_count
      this.all_fans_count = res.data.all_fans_count
    },
    onReceiveEmployeeConfirm(data) {
      this.receiveEmployeeDialogVisible = false
      setReceiveEmployee({
        employee_no: this.receiveEmployeeRow.employee_no,
        accept_employee_no: data.employee_no
      }).then(res => {
        this.$message.success('设置成功')
      })
    },
    ev_setReceiveEmployee(row) {
      this.receiveEmployeeRow = row
      this.receiveEmployeeDialogVisible = true
    },
    /** 弹窗内容在 opened 后才挂载（且 destroy-on-close 会重建子组件），此处调用 soucelisttwo.send 才会请求 enterpriseEmployee 列表 */
    loadReceiveEmployeeList() {
      this.$nextTick(() => {
        const picker = this.$refs.receiveEmployeeSoucelistview
        if (picker && typeof picker.send === 'function') {
          picker.send(1)
        }
      })
    },
    openMessageIntervalDialog(row) {
      this.messageIntervalRow = row
      this.messageIntervalMin = row.spokes_frequency.min
      this.messageIntervalMax = row.spokes_frequency.max
      this.messageIntervalDialogVisible = true
    },
    async submitMessageInterval() {
      if (!this.messageIntervalRow) {
        return
      }
      const min = this.messageIntervalMin
      const max = this.messageIntervalMax
      if (min == null || max == null) {
        this.$message.warning('请填写消息间隔')
        return
      }
      if (min > max) {
        this.$message.warning('最小间隔不能大于最大间隔')
        return
      }
      this.messageIntervalSubmitting = true
      try {
        const res = await setSpokesfrequency({
          employee_no: this.messageIntervalRow.employee_no,
          min,
          max
        })
        this.$message.success(res.message || '设置成功')
        this.messageIntervalDialogVisible = false
        this.list()
      } catch (e) {
        // 错误提示由 request 拦截器统一处理
      } finally {
        this.messageIntervalSubmitting = false
      }
    },
    openChatRobotWebhookDialog(row) {
      this.chatRobotWebhookRow = row
      this.chatRobotWebhookUrl = this.getRowWebhookUrl(row)
      this.chatRobotWebhookDialogVisible = true
    },
    fillChatRobotWebhook() {
      this.chatRobotWebhookUrl = this.getRowWebhookUrl(this.chatRobotWebhookRow)
    },
    getRowWebhookUrl(row) {
      if (!row) {
        return ''
      }
      return row.webhook_url || row.webhookUrl || ''
    },
    resetChatRobotWebhookDialog() {
      this.chatRobotWebhookRow = null
      this.chatRobotWebhookUrl = ''
    },
    async submitChatRobotWebhook() {
      if (!this.chatRobotWebhookRow) {
        return
      }
      const webhook_url = (this.chatRobotWebhookUrl || '').trim()
      if (!webhook_url) {
        this.$message.warning('请输入 webhook')
        return
      }
      this.chatRobotWebhookSubmitting = true
      try {
        const res = await setChatRobotWebhook({
          employee_no: this.chatRobotWebhookRow.employee_no,
          webhook_url
        })
        this.$message.success(res.message || '设置成功')
        this.chatRobotWebhookDialogVisible = false
        // this.list()
      } catch (e) {
        // 错误提示由 request 拦截器统一处理
      } finally {
        this.chatRobotWebhookSubmitting = false
      }
    },
    async confirmStartPush() {
      if (!this.fansType) {
        this.$message.error('请选择推粉类型')
        return
      }
      if (!this.sendNum || this.sendNum < 1) {
        this.$message.error('推送数量不能小于1')
        return
      }
      try {
        await createPushCardTask({
          employee_nos: this.multipleSelection.map(item => item.employee_no),
          fans_type: this.fansType,
          send_num: this.sendNum
        })
        this.$message({
          type: 'success',
          message: '创建推送名片任务成功!'
        })
        this.fansTypeDialogVisible = false
        this.fansType = 2
        this.sendNum = 1
        this.currentEmployeeNo = ''
      } catch (error) {
        this.$message.error('创建推送名片任务失败，请稍后重试')
      }
    },
    pushcard() {
      this.fansType = 2
      this.sendNum = 1
      this.fansTypeDialogVisible = true
      console.log('this.multipleSelection', this.multipleSelection)
      if (this.multipleSelection.length === 1) {
        this.getFansCount()
      }
    },
    setLoginPlatform(row, type) {
      this.$confirm(`此操作将设置${type === 1 ? '无' : type === 2 ? '由创' : '企微宝'}登录状态，是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          setUpLoginPlatform({
            employee_no: row.employee_no,
            login_platform: type
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.list()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    async interiorGroupPull(row) {
      console.log('row:', row)
      const res = await syncChatGroupsByUser({
        corp_id: row.corp_id,
        user_id: row.user_id
      })
      if (res.code === 200) {
        this.$message({
          message: '同步成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }

      console.log(res, 'rss')
    },
    undind(client_host, employee_no) {
      this.$confirm('您确定解绑吗')
        .then(async res => {
          await upToolunbind({
            client_host: client_host,
            employee_no: employee_no
          })
          this.bandclenddialog = false
          this.list()
          this.$message({
            message: '解绑成功',
            type: 'success'
          })
        })
        .catch(() => {})
    },
    getCellStyle(row) {
      if (row.score) {
        if (row.score < 20) {
          return { color: '#ee0c2d' }
        } else if (row.score >= 20 && row.score < 50) {
          return { color: '#ffba00' }
        } else if (row.score >= 50) {
          return { color: '#16d46b' }
        }
      }
    },
    handleCommand(command, data) {
      console.log(command, data, '111111')
    },
    handleSelectionChange(val) {
      console.log('🚀 ~ val:', val)
      this.multipleSelection = val
    },
    openSetTagDialog() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择员工')
        return
      }
      this.tagInput = ''
      this.setTagDialogVisible = true
    },
    async submitSetTag() {
      const employee_nos = this.multipleSelection.map(item => item.employee_no).filter(Boolean)
      if (employee_nos.length === 0) {
        this.$message.warning('请选择有效员工')
        return
      }
      try {
        await setCorpUserTag({
          employee_nos,
          tag: this.tagInput.trim()
        })
        this.$message.success('设置成功')
        this.setTagDialogVisible = false
        this.list()
      } catch (e) {
        this.$message.error(e.message || '设置失败')
      }
    },
    async toQRcode(ev) {
      const ids = {
        corp_user_id: ev.row.id,
        // corp_id: ev.row.corp_id,
        // user: ev.row.user_id
        user_ids: [ev.row.user_id]
      }
      localStorage.setItem('toqrcode', JSON.stringify(ids))
      this.$router.push('/Qrcode')
    },
    async list() {
      this.loading = true
      const data = await spCorpcorpUsersList(this.query)
      this.tableData = data.data.list
      this.tableData.forEach(element => {
        element.tips = false
      })
      this.total = data.data.total
      this.loading = false
      // console.log('data111111111', data)
    },
    async look(item) {
      // console.log('item', item)
      const data = await spCorpfetchExternalContacts({
        user_id: item.user_id,
        corp_id: item.corp_id
      })
      this.$message({
        message: '拉取成功',
        type: 'success'
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = null
      this.query.tag = null
      this.query.login_status = 0
      this.query.disable_status = 0
      this.query.corp_id = null
      this.query.staff_pool = null
      this.tableData = []
      // this.list()
    },
    send(item) {
      console.log('222', item)
      this.query.page = 1
      if (item.corp_name === '员工池') {
        this.query.staff_pool = 2
        this.query.corp_id = ''
        this.elxtcorp_name = item.corp_name
      } else {
        this.query.staff_pool = ''
        this.query.corp_id = item.corp_id
        this.elxtcorp_name = item.corp_name
      }

      this.list()
    },
    async anthall() {
      // console.log('授权')
      this.value = null
      this.options = []
      this.supplier()
      this.choosecontet = true
    },
    async supplier() {
      const data = await supplierlist()
      this.options = data.data.provider_list

      console.log('data', data.data.provider_list)
    },
    async anth() {
      console.log('授权')
      try {
        this.link = ''
        this.lookpassword = true
        this.loadinglink = true
        const data = await authPage({
          corp_provider_id: this.value
        })
        this.loadinglink = false
        this.link = data.data.qrcode_url
        console.log('data', data.data.qrcode_url)
      } catch {
        this.loadinglink = false
      }
    },
    choosesumbit() {
      if (this.value === null) {
        this.$message({
          message: '请选择服务商',
          type: 'error'
        })
        return
      }
      this.anth()
      this.choosecontet = false
      this.lookpassword = true
    },
    privatechat(item) {
      console.log(item)
      this.privatechatdialog = true
      this.$nextTick(() => {
        this.$refs.privatechatview.sendr(item)
      })
    },
    resetCodeOtp() {
      this.codeDigits = ['', '', '', '', '', '']
    },
    formatQrCountdown(seconds) {
      const m = Math.floor(seconds / 60)
      const s = seconds % 60
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    startQrCountdown() {
      this.clearQrCountdown()
      this.qrCountdown = 150
      this.qrCountdownTimer = setInterval(() => {
        if (this.qrCountdown <= 1) {
          this.qrCountdown = 0
          this.clearQrCountdown()
          return
        }
        this.qrCountdown--
      }, 1000)
    },
    clearQrCountdown() {
      if (this.qrCountdownTimer) {
        clearInterval(this.qrCountdownTimer)
        this.qrCountdownTimer = null
      }
    },
    focusOtpCell(index) {
      const wrap = this.$refs.otpWrap
      if (!wrap) return
      const inputs = wrap.querySelectorAll('.otp-cell')
      const el = inputs[index]
      if (el) {
        el.focus()
        try {
          el.setSelectionRange(0, 1)
        } catch (e) {
          /* ignore */
        }
      }
    },
    onOtpInput(index, e) {
      const digit = String(e.target.value || '').replace(/\D/g, '').slice(-1)
      this.$set(this.codeDigits, index, digit)
      e.target.value = digit
      if (digit && index < 5) {
        this.$nextTick(() => this.focusOtpCell(index + 1))
      }
    },
    onOtpKeydown(index, e) {
      if (e.key === 'Backspace') {
        if (!this.codeDigits[index] && index > 0) {
          e.preventDefault()
          this.$set(this.codeDigits, index - 1, '')
          this.$nextTick(() => this.focusOtpCell(index - 1))
        }
        return
      }
      if (e.key === 'ArrowLeft' && index > 0) {
        e.preventDefault()
        this.focusOtpCell(index - 1)
      } else if (e.key === 'ArrowRight' && index < 5) {
        e.preventDefault()
        this.focusOtpCell(index + 1)
      }
    },
    onOtpPaste(startIndex, e) {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData).getData('text') || ''
      const digits = text.replace(/\D/g, '').slice(0, 6 - startIndex)
      for (let j = 0; j < digits.length; j++) {
        this.$set(this.codeDigits, startIndex + j, digits[j])
      }
      const filled = startIndex + digits.length
      const next = Math.min(filled, 5)
      this.$nextTick(() => this.focusOtpCell(next))
    },
    async login(item, id) {
      try {
        this.itemobj = item
        console.log(item)
        this.qrimg = ''
        this.resetCodeOtp()
        this.qrcodedialog = true
        this.qrcodedialogloading = true
        this.startQrCountdown()
        const data = await getLoginQrcode({
          employee_no: id
        })
        this.qrcodedialogloading = false
        this.qrimg = data.data.qrcode_url
        this.area = data.data.area
        console.log('data', data)
      } catch {
        this.area = ''
        this.qrcodedialogloading = false
      } finally {
        this.clearQrCountdown()
        this.qrCountdown = 0
      }
    },
    edit(type, item, status) {
      this.admindialogstatus = true
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.admindialogview.send(type, item, status)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.admindialogview.send(type, item, status)
        })
      }
    },
    updata() {
      this.admindialogstatus = false
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      this.list()
    },
    async pulling(employee_no) {
      console.log('employee_no', employee_no)
      const data = await pullFriendList({
        employee_no: employee_no
      })
      this.$message({
        message: '拉取成功',
        type: 'success'
      })
      console.log('data', data)
    },
    closed() {
      console.log('111')
      this.$nextTick(() => {
        this.$refs.privatechatview.close()
      })
    },
    bandclient(item) {
      this.bandclenddialog = true
      this.$nextTick(() => {
        this.$refs.administratorsdiaview.send(item)
      })
    },
    async callback(item, employee_no) {
      console.log(item, employee_no)
      this.bandclenddialog = false
      const data = await upToolbindClient({
        employee_no: employee_no,
        client_host: item.client_host
      })
      this.$message({
        message: '绑定成功',
        type: 'success'
      })
      this.list()
      console.log('data', data)
    },
    async changewr(val, item) {
      console.log(val, item)
      await setReceiveMiniprogram({
        receive_miniprogram: val,
        id: item.id
      })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    lookstrategy(employee_no) {
      this.bandVisible = true
      this.$nextTick(() => {
        this.$refs.untiebandview.send(employee_no)
      })
    },
    closer() {
      this.bandVisible = false
    },
    signout(employee_no) {
      this.$confirm('确定要登出吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          upToollogout({
            employee_no: employee_no
          }).then(res => {
            this.$message({
              type: 'success',
              message: '登出成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    unblock(employee_no, disable_status) {
      this.$confirm('此操作将解封该账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          Unblocklear({
            employee_no: employee_no,
            // eslint-disable-next-line eqeqeq
            disable_status: disable_status == 1 ? 2 : 1
          }).then(res => {
            this.$message({
              type: 'success',
              message: '解封成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解封'
          })
        })
    },
    reawrgfeishu() {
      this.forwardfeishuVisible = true
      this.$nextTick(() => {
        this.$refs.forwardfeishudialogview.send(this.query.corp_id)
      })
    },
    feiupdata() {
      this.forwardfeishuVisible = false
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      this.list()
    },
    compulsorytermination(wx_id) {
      this.$confirm('此操作将强制解除静置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          upToolliftingBan({
            wx_id: wx_id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '解除成功!'
            })
            this.list()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解除'
          })
        })
    },
    updataGroup(employee_no) {
      this.$confirm('此操作将更新群聊策略, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          pullGroupStrategy({
            employee_no: employee_no
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.list()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 设置已登录
    setLogin(employee_no) {
      this.$confirm('此操作将设置为登录状态，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          setUpLogin({ employee_no: employee_no }).then(res => {
            this.$message({
              type: 'success',
              message: res.message
            })
            this.list()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    clickExport() {
      // const titleArr = ['序号id', '报名人姓名', '手机号', '创业中心活动id', '用户id', '创建时间', '更新时间', '审核状态1:审核中 2.审核通过 3.审核未通过', '活动名称', '用户姓名']// 表头中文名
      // this.tableData.pop()
      // this.exportExcel(this.tableData, 'test', titleArr, 'sheetName')
      if (this.tableData.length === 0) {
        this.$message({
          type: 'error',
          message: '请不要导出空数据'
        })
        return
      }
      console.log('this.tableData', this.tableData)
      const headers = ['企业名称', '员工编号', '标签', '员工姓名', '员工别名', '手机编号', '权重分数', '登录状态', '账号状态', '是否接收小程序', '客户端ip', '登录时间', '登出时间', '飞书客服名称', '创建时间', '创建人']
      const data = this.tableData.map(item => [
        item.corp_name,
        item.employee_no,
        item.name,
        item.alias_name,
        item.phone_name,
        item.score,
        item.online_status === 2 ? '未登录' : '已登陆',
        item.disable_status_text,
        item.receive_miniprogram === 1 ? '是' : '否',
        item.client_ip,
        item.login_at,
        item.login_out_at,
        item.kf_feishu_user_name,
        item.created_at_text,
        item.realName
      ])
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      console.log('this.timeFormate()', this.timeFormate(new Date()))
      XLSX.writeFile(workbook, `${this.elxtcorp_name}${this.timeFormate(new Date())}.xlsx`)
    },
    async sumbitr() {
      const code = this.codeDigits.join('')
      if (code.length !== 6) {
        this.$message({
          type: 'error',
          message: '请输入 6 位数字验证码'
        })
        return
      }
      const data = await loginVerifyCode({
        code,
        employee_no: this.itemobj.employee_no
      })
      this.$message({
        type: 'success',
        message: '操作成功'
      })
      this.resetCodeOtp()
      this.qrcodedialog = false
      console.log('data', data)
    },
    qrcolose() {
      console.log('guan')
      this.resetCodeOtp()
      this.clearQrCountdown()
      this.qrCountdown = 0
    },
    numberfans(employee_no) {
      this.$router.push({
        path: '/stafans/index',
        query: {
          employee_no: employee_no
        }
      })
    },
    pushonewayfriend(item) {
      console.log('item', item)
      spCorpgetOneWayFriends({
        employee_no: item.employee_no
      }).then(res => {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.list()
      })
    },
    Setloginversion(item) {
      console.log(item)
      this.setloginversionVisible = true
      this.$nextTick(() => {
        this.$refs.loginversionview.send(item)
      })
    },
    vasionupdata() {
      this.setloginversionVisible = false
      this.list()
    },
    Setloginverspeople(item) {
      console.log('item666', item.employee_no)
      this.$prompt('请输入待发送由创消息目标员工', '设置转发消息员工', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /.+/, // 至少要有一个字符
        inputErrorMessage: '请输入目标员工号'
      }).then(({ value }) => {
        messagecorrelationEmployee({
          employee_no: item.employee_no,
          target_employee_no: value
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '设置成功'
          })
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '取消输入'
        // })
      })
    },
    generatelinkrw() {
      this.generatedialofer = true
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/* .sp_view{
  padding: 30px;
} */
.tabselecr_box {
  margin-bottom: 20px;
}
.message-interval-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
}
.message-interval-label {
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  color: #606266;
  margin-right: 4px;
}
.message-interval-info {
  margin-left: 4px;
  color: #909399;
  cursor: help;
  font-size: 14px;
}
.message-interval-input {
  width: 120px;
}
.message-interval-unit {
  font-size: 14px;
  color: #606266;
}
.message-interval-sep {
  font-size: 14px;
  color: #909399;
  padding: 0 2px;
}
.qr_box {
  /* text-align: center; */
}
.qr_boxr {
  text-align: center;
}
.fullscreen /deep/ .el-dialog {
  width: 80%;
}
.codebox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  justify-content: center;
  gap: 10px;
}
.codebox-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}
.otp-block {
  width: 100%;
  max-width: 420px;
  padding: 16px 18px 14px;
  box-sizing: border-box;
}
.otp-verify-row {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}
.otp-cell {
  width: 44px;
  height: 48px;
  box-sizing: border-box;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  line-height: 1;
  color: #000;
  caret-color: #000;
  background: #fff;
  border: 1px solid #4a4a4a;
  border-radius: 6px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.otp-hint {
  margin: 12px 0 0;
  padding: 0;
  font-size: 12px;
  line-height: 1.55;
  color: #a8abb2;
  text-align: left;
}
.onc_box {
  display: flex;
  width: 550px;
  justify-content: flex-end;
  margin-top: 20px;
}
.active {
  color: green;
  font-weight: bold;
}

.inactive {
  color: gray;
}
.fans-count-box {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.fans-count-item {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
}
.butsize {
  width: 120px;
}
.btn-purple.el-button--primary {
  background-color: #9333ea;
  border-color: #9333ea;
}
.btn-purple.el-button--primary:hover,
.btn-purple.el-button--primary:focus {
  background-color: #7e22ce;
  border-color: #7e22ce;
}
.btn-purple.el-button--primary:active {
  background-color: #6b21a8;
  border-color: #6b21a8;
}
/* 扩大表格勾选列点击区域 */
.staff-table /deep/ .selection-col-expand .cell {
  padding: 0;
  cursor: pointer;
}
.staff-table /deep/ .selection-col-expand .el-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  padding: 14px 0;
  box-sizing: border-box;
}
.qr_boxr /deep/ .el-loading-spinner .circular {
  width: 60px;
  height: 60px;
}
</style>
<style>
.staff-more-menu {
  width: auto !important;
  padding: 8px 10px !important;
}
.staff-more-cols {
  display: flex;
  align-items: flex-start;
}
.staff-more-col {
  display: flex;
  flex-direction: column;
  padding: 0 4px;
}
.staff-more-col .el-button,
.staff-more-col .staff-more-sub .el-button {
  width: 140px;
  margin: 4px 0 !important;
}
.staff-more-sub {
  display: block;
}
</style>
